<template>
  <div class="ad-true" ref="adTrue">
    <div id="adtrue_tag_11562"></div>
    <!-- <script data-cfasync='false' type='text/javascript' src='//cdn.adtrue.com/rtb/async.js' async></script>
    <script type="text/javascript">
        var adtrue_tags = window.adtrue_tags || [];
        adtrue_tags.push({
            tag_id: 11562,
            width: 300,
            height: 250
        });
    </script> -->
  </div>
</template>

<script>
export default {
  mounted() {
    const ad1 = document.createElement('script')
    const ad2 = document.createElement('script')

    ad1.setAttribute('src', '//cdn.adtrue.com/rtb/async.js')
    ad1.setAttribute('async', 'async')
    ad1.setAttribute('data-cfasync', 'false')
    ad2.innerHTML = `
      var adtrue_tags = window.adtrue_tags || [];
        adtrue_tags.push({
            tag_id: 11562,
            width: 300,
            height: 250
        });
    `

    const $target = this.$refs.adTrue

    if ($target) {
      $target.appendChild(ad1)
      $target.appendChild(ad2)
    }

  }
}
</script>

<style lang="stylus" scoped>
.ad-true
  margin-top 20px
</style>




// WEBPACK FOOTER //
// AdTrue.vue?06d93ee2